"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var isBrowser = function () { return typeof window !== 'undefined'; };
exports.default = isBrowser;
